export { getEffect, getAllEffects, getEffectsByCategory, markEffectActivated, isEffectActivated, clearActivatedEffects } from './effectRegistry';
export type { EffectProps, SupernaturalEffect } from './types';

// Register all built-in effects
import { registerEffect } from './effectRegistry';
import { TextCorruption } from './TextCorruption';
import { GlitchBubble } from './GlitchBubble';
import { MessageRewrite } from './MessageRewrite';
import { MessageShatter } from './MessageShatter';
import { ScreenDistortion } from './ScreenDistortion';
import { InputHijack, INPUT_HIJACK_DEFAULT_PARAMS } from './InputHijack';

// input_hijack 本体（フック・正規化）は LineDialogView が freeInput に適用するため再エクスポート。
export { useInputHijack, normalizeInputHijackParams, INPUT_HIJACK_DEFAULT_PARAMS } from './InputHijack';
export type { InputHijackParams } from './InputHijack';

registerEffect({
  id: 'text_corruption',
  displayName: 'テキスト文字化け',
  description: '吹き出しがちらつき機械語が溢れ出してバグった状態が永続する',
  category: 'message',
  component: TextCorruption,
  defaultParams: {
    startDelayMs: 500,
    flickerDurationMs: 800,
    burstDurationMs: 600,
    expansionFactor: 4,
  }
});

registerEffect({
  id: 'glitch_bubble',
  displayName: '吹き出しグリッチ',
  description: '吹き出し全体がグリッチエフェクトを起こす',
  category: 'message',
  component: GlitchBubble,
  defaultParams: { intensity: 0.5, durationMs: 2000, intervalMs: 100, colorShift: true }
});

registerEffect({
  id: 'message_rewrite',
  displayName: 'メッセージ書き換え',
  description: '表示済みのメッセージが別の内容に書き換わる',
  category: 'message',
  component: MessageRewrite,
  defaultParams: { rewriteText: '', rewriteDelayMs: 3000, transitionType: 'glitch', transitionDurationMs: 500 }
});

registerEffect({
  id: 'message_shatter',
  displayName: 'メッセージ破壊',
  description: '吹き出しが割れて破片が飛び散る',
  category: 'message',
  component: MessageShatter,
  defaultParams: { shatterDelayMs: 2000, fragmentCount: 12, durationMs: 800, showOriginalAfter: false }
});

registerEffect({
  id: 'screen_distortion',
  displayName: '画面歪み',
  description: 'LINE画面全体に歪み・ノイズが走る',
  category: 'screen',
  component: ScreenDistortion,
  defaultParams: { distortionType: 'wave', intensity: 0.5, durationMs: 1500, recurring: false }
});

// input_hijack: 唯一 category 'input'。吹き出しではなく freeInput に作用する（spec §3.3）。
// レジストリ component は no-op（吹き出し素通し）で、実乗っ取りは LineDialogView の
// useInputHijack が freeInput へ適用する。defaultParams は spec の既定値（allowOverride:true 等）。
registerEffect({
  id: 'input_hijack',
  displayName: '入力乗っ取り',
  description: 'ユーザーが入力中のテキストが勝手に書き換わる',
  category: 'input',
  component: InputHijack,
  defaultParams: { ...INPUT_HIJACK_DEFAULT_PARAMS }
});
